import { useState, useCallback } from 'react'
import { speak } from '@/lib/tts'
import './PronunciationButton.css'

interface PronunciationButtonProps {
  text: string
  accent: 'us' | 'uk'
}

export function PronunciationButton({ text, accent }: PronunciationButtonProps) {
  const [isPlaying, setIsPlaying] = useState(false)

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()

    speak(text, accent, {
      onstart: () => setIsPlaying(true),
      onend: () => setIsPlaying(false),
    })
  }, [text, accent])

  return (
    <button
      className={`pronunciation-btn ${isPlaying ? 'playing' : ''}`}
      onClick={handleClick}
      aria-label={`Play ${accent.toUpperCase()} pronunciation`}
      title={`Play ${accent.toUpperCase()} pronunciation`}
      type="button"
    >
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 9v6h4l5 5V4L7 9H3z" />
        {isPlaying ? (
          <>
            <path className="sound-wave" d="M16.5 7.5a5 5 0 010 9" />
            <path className="sound-wave delay" d="M19 5a9 9 0 010 14" />
          </>
        ) : (
          <>
            <path d="M16.5 7.5a5 5 0 010 9" opacity="0.7" />
            <path d="M19 5a9 9 0 010 14" opacity="0.4" />
          </>
        )}
      </svg>
    </button>
  )
}
